var exports = {
  "Os": "group__B7LqcZ",
  "x_": "groupHeader__w4h5tx",
  "Az": "groupItems__lK1t01",
  "BM": "groupDivider__ev1r5p",
  "AS": "item__NboBVn",
  "Fx": "itemIcon__FDuIUV",
  "IR": "itemLabel__HYXoRK",
};

module.exports = exports;
